import {getLocale, getText} from "./configuration.service";
import {DateTime} from "luxon";

/**
 * Creates duration label from duration code, ex : "8-7" => "8 jours (7 nuits)"
 * @param duration duration code
 */
const getDurationLabel = (duration: string) => {
    const durationArray = duration.split("-");
    if (durationArray.length > 1) {
        const days = Number.parseInt(durationArray[0], 10);
        const nights = Number.parseInt(durationArray[1], 10);
        if (!isNaN(days) && !isNaN(nights)) {
            let label = "";
            label += days + " " + getText(`booking.select.duration.day${days > 1 ? "s" : ""}`);
            label += " (" + nights + " " + getText(`booking.select.duration.night${nights > 1 ? "s" : ""}`) + ")";
            return label;
        }
    }
    return "";
};

/**
 * Creates capacity label from capacity code, ex : "1-6" => "6 personnes max."
 * @param capacity duration code
 */
const getCapacityLabel = (capacity: string) => {
    const capacityArray = capacity.split("-");
    if (capacityArray.length > 1) {
        const max = capacityArray[1];
        return `${max} ${getText("booking.select.duration.capacity")}`;

    }
    return "";
};

const getDateLabel = (departureDateCode: string, format: string) => {
    return DateTime.fromFormat(departureDateCode, "dd-MM-yyyy")
        .setLocale(getLocale().replace("_", "-"))
        .toFormat(format);
};

const parseDate = (date: string) => {
    const dateArray = date.split("-");
    const month = dateArray[1] + "-" + dateArray[2];
    const day = dateArray[0];
    return [month, day];
};

export {
    getDurationLabel,
    getDateLabel,
    parseDate,
    getCapacityLabel
};
